export * from './sidenav';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@angular/material/sidenav/index.js
// module id = ../../../material/sidenav/index.js
// module chunks = 3